<!--
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-11-17 16:49:37
 * @LastEditTime: 2022-03-25 11:34:00
 * @FilePath: /teacher-h5/src/views/permission.vue
-->
<template>
  <div class="page-permission">
    <img src="@/static/images/null/empty.png" alt="" />
    <p>{{ $route.query.status | getPermissionText }}</p>
  </div>
</template>

<script>
export default {
  name: 'Permission',

  methods: {

  }
}
</script>

<style lang="less">
body {
  background: #F7F8FB;
}
.page-permission {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #70788C;

  img {
    margin-bottom: 20px;
  }
}
</style>
